var React = require('react');

function IceSkate (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M568 416h-32a8 8 0 0 0-8 8v16a23.94 23.94 0 0 1-24 24h-72v-48h-48v48H144v-48H96v48H8a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h504a64.06 64.06 0 0 0 64-64v-24a8 8 0 0 0-8-8zM264 192h56v-32h-56a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm0-64h56V96h-56a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M78.4 82.7L256 32V16a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16v80h-56a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h56v32h-56a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h56l119.3 29.9A96 96 0 0 1 512 315v37a32 32 0 0 1-32 32H64a32 32 0 0 1-32-32V144.2a64 64 0 0 1 46.4-61.5z","className":"fa-primary","key":2})]);
}

IceSkate.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = IceSkate;

IceSkate.default = IceSkate;
